import IconsTextNavigation from 'components/global/IconsTextNavigation'
import React from 'react'
import { leagueEventStore } from 'state/league/leagueEvent'
import GameConstraintModal from '../Modals/GameConstraintModal'

const GameConstraint: React.FC = () => {
  const { gameConstraintModal, setgameConstraintModal, leagueData } =
    leagueEventStore(store => ({
      gameConstraintModal: store.gameConstraintModal,
      setgameConstraintModal: store.setgameConstraintModal,
      leagueData: store.leagueData,
    }))

  return (
    <>
      <div onClick={() => setgameConstraintModal(true)}>
        <IconsTextNavigation
          iconName="GearSix"
          heading="Rounds"
          isCompleted={leagueData.statuses.roundRobinsStatuses.gameConstraints}
        />
      </div>

      {gameConstraintModal && <GameConstraintModal />}
    </>
  )
}

export default GameConstraint
